import SalaryLedger from '../../components/employee/SalaryLedger.jsx'

// เงินเดือน (Salary) — HR/Admin only. The ledger view (salary_em) with manual
// add/edit/delete, gen2 generation and CSV export. Access is gated three ways:
// the EmployeeLayout hides this tab unless canViewSalary, the route sits under
// RequireStaff, and /api/hr/salary* is HR/Admin-only in _middleware.js.
export default function EmployeeSalary() {
  return <SalaryLedger />
}
